:host {
  display: inline-block;
  color: var(--theme-tertiary-text);
  font-size: 0.75rem;
}
::slotted(a) {
  color: var(--theme-tertiary-text) !important;
}
